const stages = [
  'понимание',
  'принятие',
  'обучение',
  'практика',
  'поддержка',
  'контроль',
  'закрепление нового поведения',
];

const path = [
  'Решение',
  'Понимание',
  'Принятие',
  'Навык',
  'Практика',
  'Новый стандарт',
];

export default function ChangeByOrder() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Изменения не внедряются приказом
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Почему формального решения недостаточно, чтобы сотрудники действительно изменили поведение
        </p>

        <div className="bg-gray-900 rounded-2xl p-6 md:p-10 text-center max-w-4xl mx-auto mb-10">
          <p className="text-base md:text-xl text-white leading-relaxed font-semibold">
            Руководство может объявить: «С понедельника работаем по новой системе». Но это ещё не означает, что сотрудники действительно изменят поведение.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 max-w-4xl mx-auto mb-12">
          {stages.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
            </div>
          ))}
        </div>

        <div className="bg-teal-600 rounded-2xl p-6 md:p-10">
          <p className="text-teal-100 text-xs uppercase tracking-wider text-center mb-5">Путь от решения к результату</p>
          <div className="flex flex-wrap justify-center items-center gap-2">
            {path.map((step, i) => (
              <div key={step} className="flex items-center gap-2">
                <span className="bg-white/15 border border-white/20 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                  {step}
                </span>
                {i < path.length - 1 && (
                  <i className="ri-arrow-right-line text-teal-100"></i>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}